import React from "react";
import { Box, Chip, Paper, Stack, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { formatDateTime } from "../../../utils/getEntitiesUtils";

// Estado del anteproyecto en una línea: aprobado, con devolución o sin revisar.
export const PreReportStatus = ({ history }) => {
  if (!history) return null;
  if (history.pre_report_approved) {
    return (
      <Chip
        icon={<CheckCircleOutlineIcon />}
        color="success"
        variant="outlined"
        label={
          history.pre_report_reviewed_at
            ? `Aprobado el ${formatDateTime(history.pre_report_reviewed_at)}`
            : "Aprobado"
        }
      />
    );
  }
  if (history.pre_report_reviewed_at) {
    return (
      <Chip
        icon={<ChatBubbleOutlineIcon />}
        color="warning"
        variant="outlined"
        label={`Última devolución el ${formatDateTime(history.pre_report_reviewed_at)}`}
      />
    );
  }
  return <Chip variant="outlined" label="Sin revisar" />;
};

// El historial completo, del más viejo al más nuevo. Lo comparten la pantalla
// del tutor/revisor y la del estudiante: los dos ven exactamente lo mismo.
const PreReportFeedbackHistory = ({ history, emptyText }) => {
  if (!history) return null;
  const items = history.items || [];

  return (
    <Box sx={{ width: "100%" }}>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
        <Typography variant="h6">Devoluciones</Typography>
        <PreReportStatus history={history} />
      </Stack>
      {items.length === 0 ? (
        <Typography color="text.secondary">
          {history.pre_report_approved
            ? // Aprobado antes de que existiera el historial: el booleano quedo
              // prendido por el boton viejo, que no guardaba nada.
              "Aprobado antes de que se registraran las devoluciones; no hay historial."
            : emptyText || "Todavía no hay devoluciones."}
        </Typography>
      ) : (
        <Stack spacing={1}>
          {items.map((item) => (
            <Paper key={item.id} variant="outlined" sx={{ p: 1.5 }}>
              <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
                {item.kind === "APPROVAL" ? (
                  <Chip size="small" color="success" label="Aprobación" />
                ) : (
                  <Chip size="small" color="default" label="Devolución" />
                )}
                <Typography variant="body2" color="text.secondary">
                  {item.author_name || "Usuario eliminado"} · {formatDateTime(item.created_at)}
                </Typography>
              </Stack>
              {item.message ? (
                <Typography sx={{ whiteSpace: "pre-wrap" }}>{item.message}</Typography>
              ) : (
                <Typography color="text.secondary" fontStyle="italic">
                  Sin mensaje.
                </Typography>
              )}
            </Paper>
          ))}
        </Stack>
      )}
    </Box>
  );
};

export default PreReportFeedbackHistory;
